import { app } from '../../bootstrap/core';
import { newPortfolioState } from './newPortfolio.state';
import { newPortfolioComponent } from './newPortfolio.component';
import { NewPortfolioModel } from './newPortfolio.model';

app.config(newPortfolioState);
app.component(newPortfolioComponent.name, newPortfolioComponent);
app.factory('NewPortfolioModel', () => NewPortfolioModel);



// WEBPACK FOOTER //
// ./src/app/components/newPortfolio/newPortfolio.js